const debounce = require('lodash/debounce');

function AccordionScripts() {

    /*** ACCORDIANS 
 * preventDefault is used since the page is encapsulated by a form tag and the button triggers a form send... ****/
    $('button.accordion__toggle').click(function (e) {
        e.preventDefault();
    })

    //trigger tooltips
    $(".trigger-tooltip").tooltip()

}

window.addEventListener("DOMContentLoaded", AccordionScripts);



function components() {
    //Promobanner on homepage
    var random = Math.floor(Math.random() * $('.promo-banner').length);
    $('.promo-banner').eq(random).show();

    //Find and ETP on the education page
    $('.find-an-etf__dropdown .dropdown-item').click(function (e) {
        $('#find-an-etf-dropdown').find('.dropdown__label').html($(this).text());
    });

    var flip = {
        flipBtn: function () {
            var baseUrl = new URL(window.location.href);
            var redirectUrl = baseUrl.searchParams.get("url");
            document.getElementsByClassName("interstitial-view-btn")[0].href = redirectUrl;
        }
    }

    //Flipbutton URL -- where is this used?
    if (document.getElementsByClassName("flip-btn-url").length) {
        flip.flipBtn();
    }

}

window.addEventListener("DOMContentLoaded", components);


//SHOPIFY JAVASCRIPT
window.vaneck = (function (module, $) {
    module.shopify = {
        waitUntilSelectorExists: function (selector, callback, intervalInMiliseconds) {
            intervalInMiliseconds = intervalInMiliseconds || 200;
            var checkExist = setInterval(function () {
                if ($(selector).length) {
                    clearInterval(checkExist);
                    callback();
                }
            }, intervalInMiliseconds);
        },
        getIframeStyleTagWhenLoaded: function (callback) {
            var iframe = '.shopify-buy-frame--productSet > iframe';
            vaneck.shopify.waitUntilSelectorExists(iframe, function () {
                var checkExist = setInterval(function () {
                    var $style = $(iframe).contents().find('style');
                    if ($style.length) {
                        clearInterval(checkExist);
                        callback($style);
                    }
                }, 200);
            });

        },
        applyCssOverrides: function (cssStyleOverrides) {
            $(document).ready(function () {
                var head = $('.shopify-buy-frame--productSet > iframe').contents().find('head');
                var css = 'h1 {color: red !important!}';
                var style = document.createElement('style');

                head.append(style);
                style.type = 'text/css';

                if (style.styleSheet) {
                    // This is required for IE8 and below.
                    style.styleSheet.cssText = css;
                } else {
                    style.appendChild(document.createTextNode(css));
                }
            })
        }
    };

    return module;
}(window.vaneck || {}, jQuery));


var shopifyEvent;
if (typeof (Event) === 'function') {
    shopifyEvent = new Event('overidejs-loaded');
} else {
    shopifyEvent = document.createEvent('Event');
    shopifyEvent.initEvent('overidejs-loaded', true, true);
}

document.dispatchEvent(shopifyEvent);

window.addEventListener("DOMContentLoaded", function () {
    //this is not called for blog pages
    if ($(".page-class-insights").length == 0) {
        $(window).on('scroll', debounce(addStickyNavHeight, 50));
    }

    $('.share-widget__action.copy, .share-widget__action.print').each(function() {
        const $button = $(this);
        const defaultTitle = $button.hasClass('copy') ? 'Share' : 'Print';
        
        $button.tooltip({
            title: defaultTitle,
            placement: 'bottom',
            trigger: 'hover'
        });
    });

    $(document).on('click', '.share-widget__action.copy', function(e) {
        const $button = $(this);
        const url = $(location).attr('href');
        
        navigator.clipboard.writeText(url).then(() => {
            $button.tooltip('dispose');
            $button.tooltip({
                title: 'URL copied',
                placement: 'top',
                trigger: 'manual'
            });
            
            $button.tooltip('show');
            
            setTimeout(() => {
                $button.tooltip('hide');
                $button.tooltip('dispose');
                
                $button.tooltip({
                    title: 'Copy',
                    placement: 'bottom',
                    trigger: 'hover'
                });
            }, 2000);
        });
    });
});

//to add the sticky nav height to the header if alert bars are not available
window.addStickyNavHeight = () => {
    if ($('.alert-bar').length == 0 && $(".secondary-nav")) {
        var headerHeight = $("header.site-header").outerHeight();
        $("#root > .sticky-wrapper").height(headerHeight + $(".secondary-nav").height());
    }
}

/* Tab component */
window.addEventListener("load", function () {

    $('.content-area-tab .tablink').on('show.bs.tab', function (e) {
        $(e.currentTarget).parent().find(".active").removeClass("active"); // previous active tab
    })

    $('.content-area-tab').each(function (i, e) {
        $(e).find('.tablink:first').click();
    })
})

//add a custom class to webinar register button to be caught in the recaptcha form
window.addEventListener("load", function () {
    $(".us-webinar-page .register-cta__cta-wrapper #loginModal .webinar-submit-button").on("click", function () {
        if ($(".webinar-already-register-btn").length == 0) {
            $(this).addClass("webinar-already-register-btn");
        } 
    })
})

//DIG46-721 - Removed feature which navigated to a new page on generate email button click
window.GetSubscriptionsExistingUserMessage = async() => {
    var siteContext = $("#hdnCurrentSiteContextType").val()?.toLowerCase();
    var currentEmail = $(".main-subscription-registration-form .FormTextbox__Input.email").val()?.toLowerCase();
    try {
        typeof (doSpinner) == "function" && doSpinner();
        const data = await $.post('/common/SubscriptionsElementData/SendManageSubscriptionEmail',
            {
                siteContextType: siteContext,
                email: currentEmail
            }
        );
        $(".Form__ElementFormTextbox .status").empty();
        $(".Form__ElementFormTextbox .status").append(`<span>${data.Message}</span>`)
        typeof (stopSpinner) == "function" && stopSpinner()
    } catch (error) {
        console.error(`Error: ${error.message}`);
    }
}